// extracted by mini-css-extract-plugin
export default {"page":"Patient_page__Gw5FU","header":"Patient_header__rIx1t","headerCard":"Patient_headerCard__pV33Z","layout":"Patient_layout__nwrF-","content":"Patient_content__X1hVO"};